import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromSections from './sections.reducer';

export const selectSectionState = createSelector(selectDashboardState, (dashboard) => dashboard?.section);

export const selectIsLoadingSections = createSelector(
  selectSectionState,
  (sectionState) => sectionState?.loadingSections
);

export const selectSectionsLoaded = createSelector(selectSectionState, (sectionState) => sectionState?.sectionsLoaded);

export const selectIsLoadingSection = createSelector(
  selectSectionState,
  (sectionState) => sectionState?.loadingSection
);

export const selectSectionLoaded = createSelector(selectSectionState, (sectionState) => sectionState?.sectionLoaded);

export const selectSections = createSelector(selectSectionState, fromSections.selectAll);

export const selectSectionsSortingOrder = createSelector(
  selectSectionState,
  (sectionsState) => sectionsState?.sectionsSortingOrder
);

export const selectSorteredSections = createSelector(
  selectSections,
  selectSectionsSortingOrder,
  (sections, sectionsSortingOrder) => {
    return sectionsSortingOrder.length
      ? sections.sort(
          (section1, section2) => sectionsSortingOrder.indexOf(section1.id) - sectionsSortingOrder.indexOf(section2.id)
        )
      : sections;
  }
);

export const selectSelectedSection = createSelector(
  selectSectionState,
  (sectionState) => sectionState?.selectedSection
);
